import { useSnackbar } from "notistack";
import { ImpersonationAwareContainer } from "components/impersonation-aware-container";
import { useForgetDevice } from "hooks/api/use-forget-device";
import { useDictionary } from "hooks/use-dictionary";
import { useAuth } from "providers/auth";
import { useImpersonation } from "providers/impersonation";
import { isSuccessStatus } from "utils/is-success-status";

interface ForgetDeviceButtonProps {
  onDone?: () => void;
}

const ForgetDeviceButton = ({ onDone }: ForgetDeviceButtonProps) => {
  const { isDeviceRemembered, setIsDeviceRemembered } = useAuth();
  const { isImpersonating } = useImpersonation();
  const { mutate: forgetDevice, isPending } = useForgetDevice();
  const { enqueueSnackbar } = useSnackbar();
  const dict = useDictionary();

  if (!isDeviceRemembered || isImpersonating) {
    return null;
  }

  const handleClick = () => {
    forgetDevice(undefined, {
      onSettled: (response) => {
        if (response && isSuccessStatus(response.status)) {
          setIsDeviceRemembered(false);
          enqueueSnackbar(dict.header.forgetDeviceSuccess, { variant: "success" });
        } else {
          enqueueSnackbar(dict.header.forgetDeviceFailed, { variant: "error" });
        }

        onDone?.();
      },
    });
  };

  return (
    <ImpersonationAwareContainer>
      <button
        type="button"
        className="w-full text-center text-xs text-theme-primary hover:underline cursor-pointer disabled:opacity-50"
        disabled={isPending}
        onClick={handleClick}
      >
        {dict.header.forgetDevice}
      </button>
    </ImpersonationAwareContainer>
  );
};

export default ForgetDeviceButton;
